/* ==========================================================================
   BULLETPROOF CULTURE — MALTA'S FREE GYM TRANSFORMATIONS
   3-page submission form, shareable Stories page, live counter, nominations.
   Self-contained. Loaded only by sections/bp-free-gym.liquid.

   Nothing here pretends to send data. With no endpoint configured the form
   validates and builds the page locally, then says plainly that it was not sent.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.querySelector("[data-bp-fg]");
  if (!root) return;

  var TOTAL_PAGES = 3;
  var MAX_VIDEO_SECONDS = 16; // brief says 15s; allow rounding
  var COUNTER_POLL_MS = 20000;
  var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  var cfg = {
    submit: (root.getAttribute("data-submit-endpoint") || "").trim(),
    nominate: (root.getAttribute("data-nominate-endpoint") || "").trim(),
    counter: (root.getAttribute("data-counter-endpoint") || "").trim(),
    email: (root.getAttribute("data-entries-email") || "").trim(),
    formsubmit: root.getAttribute("data-formsubmit-base") || "https://formsubmit.co/"
  };

  // Free email delivery (FormSubmit, same service as the careers form).
  // Its documented file upload path is a normal form POST, capped at 10 MB
  // for all files together, so photos are shrunk on the device first.
  var EMAIL_LIMIT = 10 * 1024 * 1024;
  var EMAIL_MARGIN = 400 * 1024; // text fields + multipart overhead
  var PHOTO_MAX_EDGE = 1600;
  var PHOTO_QUALITY = 0.85;
  var STORE_KEY = "bp-fg-your-page";
  var EMAIL_LABELS = {
    name: "Name", birth_year: "Year of birth", id_card: "ID card number", town: "Town", gym: "Gym",
    started_month: "Started free gym (month)", started_year: "Started free gym (year)",
    category: "Category", instagram: "Instagram", phone: "Phone",
    before_free_gym: "Who were you before free gym?", what_changed: "What changed?",
    line_to_prime_minister: "One line to the Prime Minister",
    before_photo: "Before photo", after_photo: "After photo", story_video: "Story video",
    consent: "Happy for story and photos to be featured"
  };

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var heroImg = root.querySelector(".bp-fg-hero__img");
  if (heroImg && heroImg.complete) heroImg.classList.add("is-loaded");

  var form = root.querySelector("[data-fg-form]");
  var pages = form.querySelectorAll("[data-fg-page]");
  var current = 1;

  /* ---------- helpers ------------------------------------------------- */

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function scrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  }

  function showStatus(el, kind, message) {
    if (!el) return;
    el.className = "bp-fg-status" + (kind ? " bp-fg-status--" + kind : "");
    el.textContent = message;
    el.hidden = !message;
  }

  /* ---------- month / year selects ------------------------------------ */

  (function fillDates() {
    var month = $("[data-fg-months]");
    var year = $("[data-fg-years]");
    var thisYear = new Date().getFullYear();
    var i;
    if (month) for (i = 0; i < MONTHS.length; i++) {
      var m = document.createElement("option");
      m.value = MONTHS[i];
      m.textContent = MONTHS[i];
      month.appendChild(m);
    }
    if (year) for (i = 0; i < 6; i++) {
      var y = document.createElement("option");
      y.value = String(thisYear - i);
      y.textContent = String(thisYear - i);
      year.appendChild(y);
    }
  })();

  var yearBox = $("#fg-birth-year");
  if (yearBox) yearBox.addEventListener("input", function () {
    var clean = yearBox.value.replace(/\D/g, "").slice(0, 4);
    if (clean !== yearBox.value) yearBox.value = clean;
  });

  /* ---------- character counters -------------------------------------- */

  $$("[data-fg-counted]").forEach(function (area) {
    var out = $('[data-fg-count-for="' + area.id + '"]');
    var max = area.maxLength;
    var LINE = 40;
    var minH = (parseInt(area.getAttribute("rows"), 10) || 3) * LINE;
    function update() {
      area.style.height = "auto";
      area.style.height = Math.max(minH, Math.ceil(area.scrollHeight / LINE) * LINE) + "px";
      if (!out) return;
      out.textContent = area.value.length + " / " + max;
      out.classList.toggle("is-near", area.value.length >= max * 0.9);
    }
    area.addEventListener("input", update);
    update();
  });

  /* ---------- photo + video pickers ----------------------------------- */

  $$("[data-fg-upload]").forEach(function (wrap) {
    var input = $("input[type=file]", wrap);
    var box = $(".bp-fg-upload__box", wrap);
    var isVideo = wrap.classList.contains("bp-fg-upload--video");
    var url = null;

    input.addEventListener("change", function () {
      var file = input.files && input.files[0];
      var old = $("img", box);
      var nameEl = $(".bp-fg-upload__name", box);
      if (old) old.remove();
      if (nameEl) nameEl.remove();
      if (url) { URL.revokeObjectURL(url); url = null; }
      wrap.classList.remove("has-file");
      clearFieldError(fieldOf(input));
      if (!file) return;

      if (isVideo) {
        if (file.type.indexOf("video/") !== 0) { input.value = ""; setFieldError(fieldOf(input), input, "Choose a video file."); return; }
        var probe = document.createElement("video");
        var probeUrl = URL.createObjectURL(file);
        probe.preload = "metadata";
        probe.onloadedmetadata = function () {
          URL.revokeObjectURL(probeUrl);
          if (isFinite(probe.duration) && probe.duration > MAX_VIDEO_SECONDS) {
            input.value = "";
            setFieldError(fieldOf(input), input, "Keep it to 15 seconds. Yours is " + Math.round(probe.duration) + ".");
            return;
          }
          markFile(file);
        };
        probe.onerror = function () { URL.revokeObjectURL(probeUrl); markFile(file); };
        probe.src = probeUrl;
      } else {
        if (file.type.indexOf("image/") !== 0) { input.value = ""; setFieldError(fieldOf(input), input, "Choose an image file."); return; }
        url = URL.createObjectURL(file);
        var img = document.createElement("img");
        img.alt = "";
        img.src = url;
        box.insertBefore(img, box.firstChild);
        markFile(file);
      }
    });

    function markFile(file) {
      var name = document.createElement("span");
      name.className = "bp-fg-upload__name";
      name.textContent = file.name;
      box.appendChild(name);
      wrap.classList.add("has-file");
    }
  });

  /* ---------- validation ---------------------------------------------- */

  function fieldOf(control) {
    var n = control;
    while (n && n !== root) {
      if (n.hasAttribute && n.hasAttribute("data-fg-field")) return n;
      n = n.parentNode;
    }
    return null;
  }

  function setFieldError(field, control, message) {
    if (!field) return;
    var err = $("[data-fg-error]", field);
    if (err) { err.textContent = message; err.hidden = false; }
    $$("input, select, textarea", field).forEach(function (c) { c.setAttribute("aria-invalid", "true"); });
  }

  function clearFieldError(field) {
    if (!field) return;
    var err = $("[data-fg-error]", field);
    if (err) { err.textContent = ""; err.hidden = true; }
    $$("input, select, textarea", field).forEach(function (c) { c.removeAttribute("aria-invalid"); });
  }

  var MISSING = {
    name: "Write your name and surname.",
    birth_year: "Add the year you were born.",
    id_card: "Add your ID card number. We need it as proof of age.",
    town: "Add your town.",
    gym: "Add the gym you train at.",
    instagram: "Add your Instagram handle.",
    phone: "Add a number we can reach you on.",
    started_month: "Pick the month and year you started.",
    category: "Pick guy or girl.",
    before_free_gym: "Write a line or two here.",
    what_changed: "Write a line or two here.",
    line_to_prime_minister: "Write your line to the Prime Minister.",
    before_photo: "Add your before photo.",
    after_photo: "Add your after photo.",
    consent: "Tick this so we can feature your page.",
    nominator_name: "Add your name.",
    nominator_relationship: "Pick one.",
    nominee_name: "Add their name.",
    nominee_phone: "Add their phone number."
  };
  function missing(name, fallback) { return MISSING[name] || fallback; }

  function problemWith(field) {
    var controls = $$("input, select, textarea", field).filter(function (c) { return c.type !== "hidden"; });
    if (!controls.length) return "";
    var c = controls[0];
    var name = c.name;
    var value = (c.value || "").trim();
    var thisYear = new Date().getFullYear();

    if (c.type === "radio") {
      var picked = controls.some(function (r) { return r.checked; });
      return picked ? "" : missing(name, "Pick one.");
    }
    if (c.type === "checkbox") return c.checked ? "" : missing(name, "Tick this to continue.");
    if (c.type === "file") {
      if (c.required && !(c.files && c.files.length)) return missing(name, "Add a photo to continue.");
      return "";
    }
    if (field.querySelector("select")) {
      var empty = controls.some(function (s) { return s.required && !s.value; });
      return empty ? missing(name, "Choose one.") : "";
    }
    if (c.required && !value) return missing(name, "Fill this in.");

    if (name === "birth_year") {
      var yr = parseInt(value, 10);
      if (!/^\d{4}$/.test(value) || yr < 1900 || yr > thisYear) return "Enter a four digit year, like 2006.";
    }
    if (name === "id_card") {
      if (!/^[A-Za-z0-9]{4,12}$/.test(value.replace(/\s/g, ""))) return "Letters and numbers only, like 123456M.";
    }
    if (name === "instagram") {
      if (!/^@?[A-Za-z0-9._]{1,30}$/.test(value)) return "Letters, numbers, dots and underscores only.";
    }
    if (name === "phone" || name === "nominee_phone") {
      var digits = value.replace(/\D/g, "");
      if (digits.length < 7 || digits.length > 15) return "Enter a phone number with country code if outside Malta.";
    }
    if (c.maxLength > 0 && value.length > c.maxLength) return "Keep it to " + c.maxLength + " characters.";
    return "";
  }

  function validateWithin(container) {
    var first = null;
    $$("[data-fg-field]", container).forEach(function (field) {
      var message = problemWith(field);
      if (message) {
        setFieldError(field, null, message);
        if (!first) first = $$("input, select, textarea", field)[0];
      } else {
        clearFieldError(field);
      }
    });
    if (first) { try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); } }
    return !first;
  }

  // Clear an error as soon as the person fixes the field.
  root.addEventListener("input", function (e) { var f = fieldOf(e.target); if (f) clearFieldError(f); });
  root.addEventListener("change", function (e) { var f = fieldOf(e.target); if (f && e.target.type !== "file") clearFieldError(f); });

  /* ---------- paging --------------------------------------------------- */

  var label = $("[data-fg-progress-label]");
  var dots = $$(".bp-fg-progress__dots i");
  var backBtn = $("[data-fg-back]");
  var nextBtn = $("[data-fg-next]");
  var submitBtn = $("[data-fg-submit]");
  var folio = $("[data-fg-folio]");
  var status = $("[data-fg-status]");

  var pagesWrap = $("[data-fg-pages]");
  var resizeTimer = null;

  function showPage(n, move) {
    var from = pagesWrap.offsetHeight;
    var animateHeight = move && !reduceMotion && from > 0;
    if (animateHeight) {
      clearTimeout(resizeTimer);
      pagesWrap.style.height = from + "px";
      pagesWrap.classList.add("is-resizing");
    }

    current = n;
    pages.forEach(function (p, i) {
      var on = i + 1 === n;
      p.hidden = !on;
      p.classList.remove("is-entering");
      if (on && move) { void p.offsetWidth; p.classList.add("is-entering"); }
    });

    if (animateHeight) {
      pagesWrap.style.transition = "none";
      pagesWrap.style.height = "";
      var natural = pagesWrap.getBoundingClientRect().height;
      pagesWrap.style.height = from + "px";
      void pagesWrap.offsetHeight;
      pagesWrap.style.transition = "";
      pagesWrap.style.height = natural + "px";
      resizeTimer = setTimeout(function () {
        pagesWrap.style.height = "";
        pagesWrap.classList.remove("is-resizing");
      }, 480);
    }

    label.textContent = "Page " + n + " of " + TOTAL_PAGES;
    dots.forEach(function (d, i) {
      d.className = i + 1 < n ? "is-done" : i + 1 === n ? "is-current" : "";
    });
    folio.innerHTML = "&mdash; " + n + " &mdash;";
    backBtn.hidden = n === 1;
    nextBtn.hidden = n === TOTAL_PAGES;
    submitBtn.hidden = n !== TOTAL_PAGES;
    showStatus(status, "", "");
    if (move) {
      scrollTo(form);
      var legend = $("legend", pages[n - 1]);
      if (legend) legend.focus({ preventScroll: true });
    }
  }

  nextBtn.addEventListener("click", function () {
    if (validateWithin(pages[current - 1])) showPage(current + 1, true);
  });
  backBtn.addEventListener("click", function () { if (current > 1) showPage(current - 1, true); });

  /* ---------- posting -------------------------------------------------- */

  function post(endpoint, formData) {
    return fetch(endpoint, { method: "POST", body: formData, headers: { Accept: "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json().catch(function () { return {}; });
      });
  }

  function cleanHandle(v) { return (v || "").trim().replace(/^@/, ""); }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var hp = form.querySelector('[name="_honey"]');
    if (hp && hp.value.trim()) return; // bot

    // Enter pressed in a field before the last page: behave like "Next page".
    if (current < TOTAL_PAGES) {
      if (validateWithin(pages[current - 1])) showPage(current + 1, true);
      return;
    }

    for (var i = 0; i < pages.length; i++) {
      if (!validateWithin(pages[i])) { if (current !== i + 1) showPage(i + 1, true); return; }
    }

    var beforeInput = form.querySelector('[name="before_photo"]');
    var afterInput = form.querySelector('[name="after_photo"]');
    var videoInput = form.querySelector('[name="story_video"]');
    var data = {
      name: form.querySelector('[name="name"]').value.trim(),
      town: form.querySelector('[name="town"]').value.trim(),
      pm: form.querySelector('[name="line_to_prime_minister"]').value.trim()
    };

    submitBtn.disabled = true;
    var idle = submitBtn.innerHTML;
    submitBtn.textContent = "Making your page...";

    function failed(message) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = idle;
      showStatus(status, "error", message);
    }

    Promise.all([shrinkPhoto(beforeInput.files[0], "before.jpg"), shrinkPhoto(afterInput.files[0], "after.jpg")])
      .then(function (photos) {
        data.beforeFile = photos[0];
        data.afterFile = photos[1];
        return renderCard(data).then(function () { return photos; });
      })
      .then(function (photos) {
        var video = videoInput.files[0] || null;

        if (cfg.submit) {
          var fd = new FormData(form);
          fd.delete("_honey");
          fd.set("instagram", cleanHandle(fd.get("instagram")));
          fd.set("before_photo", photos[0], photos[0].name);
          fd.set("after_photo", photos[1], photos[1].name);
          if (!video) fd.delete("story_video");
          return post(cfg.submit, fd).then(function () {
            submitBtn.disabled = false;
            submitBtn.innerHTML = idle;
            revealResult("Your story is in. Share your page to Stories and tag us.");
          }, function () {
            failed("Could not send your entry just now. Nothing was lost on this page: check your connection and try again.");
          });
        }

        if (cfg.email) return sendByEmail(photos, video, failed);

        submitBtn.disabled = false;
        submitBtn.innerHTML = idle;
        revealResult("Not sent. This form is not connected to an inbox yet, so your story, photos and details have not been saved anywhere. This is how your page will look.");
      })
      .catch(function () {
        failed("Something went wrong making your page. Try again, or try different photos.");
      });
  });

  function shrinkPhoto(file, name) {
    if (!file) return Promise.resolve(file);
    return fileImage(file).then(function (img) {
      if (!img) return file;
      var scale = Math.min(1, PHOTO_MAX_EDGE / Math.max(img.width, img.height));
      var c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      return new Promise(function (resolve) {
        c.toBlob(function (b) {
          resolve(b && b.size < file.size ? new File([b], name, { type: "image/jpeg" }) : file);
        }, "image/jpeg", PHOTO_QUALITY);
      });
    });
  }

  function setFiles(input, files) {
    var dt = new DataTransfer();
    files.forEach(function (f) { dt.items.add(f); });
    input.files = dt.files;
  }

  // Email path: a normal multipart POST to FormSubmit, which then sends the
  // person back here (?entry=sent) where their saved card is shown again.
  function sendByEmail(photos, video, failed) {
    var videoNote = "";
    try {
      setFiles(form.querySelector('[name="before_photo"]'), [photos[0]]);
      setFiles(form.querySelector('[name="after_photo"]'), [photos[1]]);
    } catch (e) { /* very old browser: originals are sent as picked */ }

    var used = form.querySelector('[name="before_photo"]').files[0].size + form.querySelector('[name="after_photo"]').files[0].size;
    if (used + EMAIL_MARGIN > EMAIL_LIMIT) {
      failed("Your photos are too big to send. Try smaller photos, or take screenshots of them and add those.");
      return;
    }
    if (video && used + video.size + EMAIL_MARGIN > EMAIL_LIMIT) {
      form.querySelector('[name="story_video"]').value = "";
      videoNote = " Your video was too big to send here, so your entry went without it. DM it to @bulletproofculture on Instagram.";
    }

    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ card: canvas.toDataURL("image/jpeg", 0.92), note: videoNote }));
    } catch (e) { /* storage blocked: they still get the confirmation */ }

    var ig = form.querySelector('[name="instagram"]');
    ig.value = cleanHandle(ig.value);

    // Keep the whole address (theme preview, ?view=...) so they land back on this exact page.
    var backUrl = new URL(location.href);
    backUrl.searchParams.set("entry", "sent");
    backUrl.hash = "your-page";
    var back = backUrl.toString();
    var name = form.querySelector('[name="name"]').value.trim();
    var town = form.querySelector('[name="town"]').value.trim();
    addHidden("_subject", "Free Gym Transformations: " + name + (town ? ", " + town : ""));
    addHidden("_template", "table");
    addHidden("_captcha", "false");
    addHidden("_next", back);

    $$("[name]", form).forEach(function (el) {
      if (EMAIL_LABELS[el.name]) { el.setAttribute("data-fg-name", el.name); el.name = EMAIL_LABELS[el.name]; }
    });
    if (!form.querySelector('[name="Story video"]').files.length) form.querySelector('[name="Story video"]').disabled = true;

    form.action = cfg.formsubmit + encodeURIComponent(cfg.email);
    form.method = "POST";
    form.enctype = "multipart/form-data";
    submitBtn.textContent = "Sending your page...";
    HTMLFormElement.prototype.submit.call(form);
  }

  function addHidden(name, value) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = name; form.appendChild(el); }
    el.value = value;
  }

  // Coming back with the browser's back button: undo the email-only renames.
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    $$("[data-fg-name]", form).forEach(function (el) { el.name = el.getAttribute("data-fg-name"); el.disabled = false; });
    submitBtn.disabled = false;
    submitBtn.textContent = "Make my page";
  });

  /* ---------- your page (canvas, 1080 x 1920) --------------------------- */

  var result = $("[data-fg-result]");
  var canvas = $("[data-fg-card]");
  var resultNote = $("[data-fg-result-note]");

  function loadImage(src, cors) {
    return new Promise(function (resolve) {
      var img = new Image();
      if (cors) img.crossOrigin = "anonymous";
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function fileImage(file) {
    var u = URL.createObjectURL(file);
    return loadImage(u).then(function (img) { URL.revokeObjectURL(u); return img; });
  }

  function drawCover(ctx, img, x, y, w, h) {
    if (!img) { ctx.fillStyle = "#cdd0d1"; ctx.fillRect(x, y, w, h); return; }
    var s = Math.max(w / img.width, h / img.height);
    var sw = w / s, sh = h / s;
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) * 0.4, sw, sh, x, y, w, h);
    ctx.restore();
  }

  function wrapLines(ctx, text, maxWidth) {
    var words = text.split(/\s+/), lines = [], line = "";
    words.forEach(function (w) {
      var test = line ? line + " " + w : w;
      if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = w; } else { line = test; }
    });
    if (line) lines.push(line);
    return lines;
  }

  // Instagram lays its progress bar and profile over roughly the top 250px of
  // a 1080x1920 story, and the reply bar over roughly the bottom 250px, so
  // everything that has to be read sits between SAFE_TOP and SAFE_BOTTOM.
  // Layout: masthead, before/after side by side (the hero), the line to the
  // Prime Minister, then the name.
  function drawCard(d, beforeImg, afterImg, logoImg) {
    var W = 1080, H = 1920, PAD = 72, SAFE_TOP = 250, SAFE_BOTTOM = 1670;
    var Y0 = SAFE_TOP + 90; // centres the block between the two overlays
    var INK = "#080808", PAPER = "#f3f2ee", MUTED = "rgba(243, 242, 238, 0.62)", YELLOW = "#f5d013";
    var ctx = canvas.getContext("2d");
    var sans = '"Helvetica Neue", Helvetica, Arial, sans-serif';
    var mono = 'ui-monospace, "SF Mono", Menlo, "Roboto Mono", monospace';
    canvas.width = W; canvas.height = H;
    ctx.textBaseline = "alphabetic";
    ctx.textAlign = "left";

    ctx.fillStyle = INK; ctx.fillRect(0, 0, W, H);

    // masthead
    if (logoImg) {
      var lw = 300, lh = lw * (logoImg.height / logoImg.width);
      ctx.drawImage(logoImg, PAD, Y0, lw, lh);
    } else {
      ctx.fillStyle = PAPER; ctx.font = "800 34px " + sans;
      ctx.fillText("BULLETPROOF", PAD, Y0 + 30);
    }
    ctx.fillStyle = MUTED; ctx.font = "700 22px " + mono; ctx.textAlign = "right";
    ctx.fillText("FREE GYM TRANSFORMATIONS", W - PAD, Y0 + 26);
    ctx.textAlign = "left";
    ctx.fillStyle = "rgba(243, 242, 238, 0.18)"; ctx.fillRect(PAD, Y0 + 62, W - PAD * 2, 2);

    // before / after, the hero of the card
    var gap = 16, pw = (W - PAD * 2 - gap) / 2, ph = 780, py = Y0 + 100;
    [[beforeImg, PAD, "Before"], [afterImg, PAD + pw + gap, "After"]].forEach(function (p) {
      drawCover(ctx, p[0], p[1], py, pw, ph);
      var g = ctx.createLinearGradient(0, py + ph - 180, 0, py + ph);
      g.addColorStop(0, "rgba(8, 8, 8, 0)");
      g.addColorStop(1, "rgba(8, 8, 8, 0.72)");
      ctx.fillStyle = g; ctx.fillRect(p[1], py + ph - 180, pw, 180);
      ctx.fillStyle = PAPER; ctx.font = "700 34px " + sans;
      ctx.fillText(p[2], p[1] + 26, py + ph - 30);
    });

    // the line to the Prime Minister
    var top = py + ph + 76;
    ctx.fillStyle = YELLOW; ctx.font = "700 22px " + mono;
    ctx.fillText("TO THE PRIME MINISTER", PAD, top);
    var quote = "\u201C" + d.pm + "\u201D";
    var size = 84, lines, lead, first, last = SAFE_BOTTOM - 86;
    for (;;) {
      ctx.font = "800 " + size + "px " + sans;
      lines = wrapLines(ctx, quote.toUpperCase(), W - PAD * 2);
      lead = size * 0.98;
      first = top + 28 + size * 0.86;
      if (first + (lines.length - 1) * lead <= last || size <= 40) break;
      size -= 4;
    }
    ctx.fillStyle = PAPER;
    lines.forEach(function (l, i) { ctx.fillText(l, PAD, first + i * lead); });

    // name, town (shrinks to fit long names)
    var who = d.name + (d.town ? ", " + d.town : "");
    var whoSize = 34;
    do { ctx.font = "500 " + whoSize + "px " + sans; whoSize -= 2; }
    while (ctx.measureText(who).width > W - PAD * 2 && whoSize > 20);
    ctx.fillStyle = MUTED;
    ctx.fillText(who, PAD, first + (lines.length - 1) * lead + 66);
  }

  function renderCard(d) {
    return Promise.all([fileImage(d.beforeFile), fileImage(d.afterFile), loadImage(BP_FG_LOGO_SRC)])
      .then(function (imgs) { drawCard(d, imgs[0], imgs[1], imgs[2]); });
  }

  function revealResult(note) {
    resultNote.textContent = note;
    submitted = true;
    activePanel = form;
    showPanel("book", null, true);
    result.focus({ preventScroll: true });
  }

  // Back from FormSubmit: show the card they made before leaving.
  function restoreAfterEmail() {
    if (new URLSearchParams(location.search).get("entry") !== "sent") return;
    var clean = new URL(location.href);
    clean.searchParams.delete("entry");
    clean.hash = "your-page";
    history.replaceState(null, "", clean.toString());
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null"); sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    var note = "Your story is in. Share your page to Stories and tag us.";
    if (!saved || !saved.card) {
      canvas.hidden = true;
      $("[data-fg-share]").hidden = true;
      $("[data-fg-download]").hidden = true;
      revealResult("Your story is in. Thank you for writing your page.");
      return;
    }
    loadImage(saved.card).then(function (img) {
      canvas.width = 1080; canvas.height = 1920;
      if (img) canvas.getContext("2d").drawImage(img, 0, 0, 1080, 1920);
      revealResult(note + (saved.note || ""));
    });
  }

  function cardBlob(cb) {
    try { canvas.toBlob(function (b) { cb(b); }, "image/png"); } catch (e) { cb(null); }
  }

  $("[data-fg-download]").addEventListener("click", function () {
    cardBlob(function (blob) {
      if (!blob) { resultNote.textContent = "Could not export the image in this browser. Take a screenshot of the page above."; return; }
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "malta-free-gym-transformations-page.png";
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
    });
  });

  $("[data-fg-share]").addEventListener("click", function () {
    cardBlob(function (blob) {
      if (!blob) { resultNote.textContent = "Could not export the image in this browser. Take a screenshot of the page above."; return; }
      var file = new File([blob], "malta-free-gym-transformations-page.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: "Malta's Free Gym Transformations" }).catch(function () {});
      } else {
        $("[data-fg-download]").click();
        resultNote.textContent = "Saved. Open Instagram, add it to your Story and tag @bulletproofculture.";
      }
    });
  });

  /* ---------- live counter -------------------------------------------- */

  (function counter() {
    if (!cfg.counter) return;
    var box = $("[data-fg-counter]");
    var out = $("[data-fg-counter-n]");
    var unit = $("[data-fg-counter-unit]");
    function tick() {
      fetch(cfg.counter, { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (j) {
          var n = Number(j && j.count);
          if (!isFinite(n) || n < 0) throw new Error();
          if (n < 1) { box.hidden = true; return; } // no "0 stories" at launch
          out.textContent = n.toLocaleString("en-US");
          if (unit) unit.textContent = n === 1 ? "story submitted" : "stories submitted";
          box.hidden = false;
        })
        .catch(function () { /* keep the last good number, or stay hidden */ });
    }
    tick();
    setInterval(function () { if (!document.hidden) tick(); }, COUNTER_POLL_MS);
  })();

  /* ---------- book / nominate switcher ---------------------------------- */

  var deck = $("[data-fg-deck]");
  var nom = $("[data-fg-nominate]");
  var nomStatus = $("[data-fg-nominate-status]");
  var tabs = $$("[data-fg-tab]");
  var submitted = false;
  var activePanel = form;
  var swapTimer = null;

  function bookPanel() { return submitted ? result : form; }

  function showPanel(which, focusTarget, forceScroll) {
    var next = which === "nominate" ? nom : bookPanel();
    tabs.forEach(function (t) {
      t.setAttribute("aria-pressed", String(t.getAttribute("data-fg-tab") === which));
    });

    var topNow = deck.getBoundingClientRect().top;
    if (forceScroll || topNow < 60 || topNow > window.innerHeight * 0.6) scrollTo(deck);

    if (next === activePanel && !next.hidden) return;

    function enter() {
      activePanel.hidden = true;
      activePanel.classList.remove("is-leaving");
      activePanel = next;
      next.hidden = false;
      next.classList.remove("is-entering");
      void next.offsetWidth;
      if (!reduceMotion) next.classList.add("is-entering");
      var f = focusTarget || (next === nom ? $("[data-fg-nominate-title]", nom) : null);
      if (f) f.focus({ preventScroll: true });
    }

    clearTimeout(swapTimer);
    if (reduceMotion) { enter(); return; }
    activePanel.classList.add("is-leaving");
    swapTimer = setTimeout(enter, 150);
  }

  tabs.forEach(function (t) {
    t.addEventListener("click", function () { showPanel(t.getAttribute("data-fg-tab")); });
  });

  $$('a[href="#bp-fg-form"]', document).forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); showPanel("book", null, true); });
  });
  if (nom) {
  $("[data-fg-nominate-close]").addEventListener("click", function () {
    showStatus(nomStatus, "", "");
    showPanel("book");
  });
  if (location.hash === "#nominate") showPanel("nominate", null, true);
  window.addEventListener("hashchange", function () {
    if (location.hash === "#nominate") showPanel("nominate", null, true);
  });

  nom.addEventListener("submit", function (e) {
    e.preventDefault();
    var hp = nom.querySelector('[name="_honey"]');
    if (hp && hp.value.trim()) return;
    if (!validateWithin(nom)) return;
    var sentMsg = "Nomination sent. We'll text them an invite to write their page.";
    if (cfg.nominate) {
      var fd = new FormData(nom);
      fd.delete("_honey");
      post(cfg.nominate, fd).then(function () {
        showStatus(nomStatus, "ok", sentMsg);
        nom.reset();
      }).catch(function () {
        showStatus(nomStatus, "error", "Could not send the nomination just now. Try again in a moment.");
      });
      return;
    }
    if (!cfg.email) {
      showStatus(nomStatus, "", "Not sent. Nominations are not connected to an inbox yet.");
      return;
    }
    var v = function (n) { var el = nom.querySelector('[name="' + n + '"]:checked') || nom.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ""; };
    var payload = new FormData();
    payload.append("Nominated by", v("nominator_name"));
    payload.append("Relationship", v("nominator_relationship"));
    payload.append("Nominee name", v("nominee_name"));
    payload.append("Nominee phone", v("nominee_phone"));
    payload.append("_subject", "Free Gym Transformations: nomination for " + v("nominee_name"));
    payload.append("_template", "table");
    payload.append("_captcha", "false");
    fetch(cfg.formsubmit + "ajax/" + encodeURIComponent(cfg.email), {
      method: "POST", headers: { Accept: "application/json" }, body: payload
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) { return { ok: res.ok, body: body || {} }; });
    }).then(function (r) {
      var msg = typeof r.body.message === "string" ? r.body.message : "";
      if (r.ok && !(r.body.success === false || r.body.success === "false")) {
        showStatus(nomStatus, "ok", sentMsg);
        nom.reset();
      } else if (/activat/i.test(msg)) {
        showStatus(nomStatus, "error", "This form needs a one-time activation. Check the entries inbox for an email from FormSubmit and click Activate Form.");
      } else {
        showStatus(nomStatus, "error", msg || "Could not send the nomination just now. Try again in a moment.");
      }
    }).catch(function () {
      showStatus(nomStatus, "error", "Could not send the nomination just now. Try again in a moment.");
    });
  });
  }

  restoreAfterEmail();
  showPage(1, false);
})();

/* White Bulletproof logo for the Stories image. Embedded so the export never
   depends on the CDN sending cross-origin headers (a tainted canvas cannot be
   saved or shared). Source: assets/bulletproof-logo-white.avif, 800x83. */
var BP_FG_LOGO_SRC = "data:image/png;base64,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";

